import { useEffect, useState } from 'react';

import { Section } from '../data/beans';
import { Seating } from '../data/beans/Section';

/** Show the snapshot immediately, then refresh visible sections from Banner. */
export default function useSeating(section: Section, term: string): Seating {
  const [state, setState] = useState({ section, seating: section.seating });
  useEffect(() => {
    let cancelled = false;
    const refresh = (): void => {
      if (document.visibilityState === 'hidden') return;
      section
        .fetchSeating(term)
        .then((seating) => {
          if (!cancelled) setState({ section, seating });
        })
        .catch(() => {
          if (!cancelled) setState({ section, seating: section.seating });
        });
    };
    refresh();
    const timer = window.setInterval(refresh, 60000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [section, term]);
  return state.section === section ? state.seating : section.seating;
}
